exports.default = {
  // 相对时间
  'just_now': '剛剛',
  'minutes_ago': '分鐘前',
  'hours_ago': '小時前',
  'yesterday': '昨天',
  
  // 星期
  'week_days': ['日', '一', '二', '三', '四', '五', '六'],
  
  // 月份
  'months': ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
  'months_short': ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
  
  // 日期格式
  'date_format': {
    'year': '年',
    'month': '月',
    'day': '日',
    'hour': '時',
    'minute': '分',
    'second': '秒'
  },
  
  // 默认格式模板
  'default_formats': {
    'date': '{y}年{m}月{d}日',
    'datetime': '{y}年{m}月{d}日 {h}:{i}:{s}',
    'month_day': '{m}月{d}日',
    'time': '{h}:{i}:{s}'
  }
} 
